// "dd/mm/yyyy"
// "dd/mm/yy"
// "yyyy/mm/dd"
// "hh:mm"
// "hh:mm:ss"
// "dd/mm/yyyy hh:mm"
// FORMDATE_WITH_TIME
// "dd/mmmm/yyyy hh:mm"
// " hh:mm dd/mmmm/yyyy"

const formatDate = (date) => {
  let parts = date?.split('/');
  let d;

  const [first, second, third] = parts.map(Number);
  const isDayFirst = first < 1000;

  d = new Date(
    isDayFirst ? third : first,
    (second || 1) - 1,         
    isDayFirst ? first : third
  );

  return d;
}

const getDate = (dt, type, divider) => {
  const currentNewDate = new Date();
  const devider = divider ?? "/";

  let d;

  if (typeof dt === 'number') {
    d = new Date(dt);
  } else if (typeof dt === 'string') {
    const isoCompatible = dt.replace(' ', 'T'); // "2025-08-05 09:31:19.000Z" => "2025-08-05T09:31:19.000Z"
    d = new Date(isoCompatible);

    if (isNaN(d.getTime())) {
      d = currentNewDate;
    }
  } else {
    d = currentNewDate;
  }

  const date = d; // вже в локальному часі

  const addNull = (param) => param.toString().padStart(2, '0');

  const retMonth = (param) => {
    return [
      'Січня', 'Лютого', 'Березня', 'Квітня', 'Травня', 'Червня',
      'Липня', 'Серпня', 'Вересня', 'Жовтня', 'Листопада', 'Грудня'
    ][param] || param;
  }

  switch (type) {
    case "dd/mm/yyyy":
      return `${addNull(date.getDate())}${devider}${addNull(date.getMonth() + 1)}${devider}${date.getFullYear()}`;
    case "dd/mm/yy":
      return `${addNull(date.getDate())}${devider}${addNull(date.getMonth() + 1)}${devider}${date.getFullYear().toString().slice(-2)}`;
    case "yyyy/mm/dd":
      return `${date.getFullYear()}${devider}${addNull(date.getMonth() + 1)}${devider}${addNull(date.getDate())}`;
    case "hh:mm":
      return `${addNull(date.getHours())}${devider}${addNull(date.getMinutes())}`;
    case "hh:mm:ss":
      return `${addNull(date.getHours())}${devider}${addNull(date.getMinutes())}${devider}${addNull(date.getSeconds())}`;
    case "dd/mm/yyyy hh:mm":
      return `${addNull(date.getDate())}${devider}${addNull(date.getMonth() + 1)}${devider}${date.getFullYear()} ${addNull(date.getHours())}:${addNull(date.getMinutes())}`;
    case "hh:mm dd/mm/yyyy":
      return `${addNull(date.getHours())}:${addNull(date.getMinutes())} ${addNull(date.getDate())}${devider}${addNull(date.getMonth() + 1)}${devider}${date.getFullYear()}`;
    case "FORMDATE_WITH_TIME":
      return `${date.getFullYear()}-${addNull(date.getMonth() + 1)}-${addNull(date.getDate())}T${addNull(date.getHours())}:${addNull(date.getMinutes())}`;
    case "dd/mmmm/yyyy hh:mm":
      return `${addNull(date.getDate())}${devider}${retMonth(date.getMonth())}${devider}${date.getFullYear()} ${addNull(date.getHours())}:${addNull(date.getMinutes())}`;
    case "dd/mm/yyyy hh:mm:ss":
      return `${addNull(date.getDate())}${devider}${addNull(date.getMonth() + 1)}${devider}${date.getFullYear()} ${addNull(date.getHours())}:${addNull(date.getMinutes())}:${addNull(date.getSeconds())}`;
    case "hh:mm dd/mmmm/yyyy":
      return `${addNull(date.getHours())}:${addNull(date.getMinutes())} ${addNull(date.getDate())}${devider}${retMonth(date.getMonth())}${devider}${date.getFullYear()}`;
    case "dd/mmmm/yyyy":
      return `${addNull(date.getDate())}${devider}${retMonth(date.getMonth())}${devider}${date.getFullYear()}`;
    default:
      return date;
  }
};

export default getDate;
